import { render, staticRenderFns } from "./Unit.vue?vue&type=template&id=65ae87c8&"
import script from "./Unit.vue?vue&type=script&lang=js&"
export * from "./Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports